const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

class RealtimeClient {
  constructor() {
    this.ws = null;
    this.handlers = new Set();
    this.boards = new Set();
    this.retry = 0;
    this.shouldRun = false;
    this.timer = null;
  }

  connect() {
    this.shouldRun = true;
    this._open();
  }

  _open() {
    if (!this.shouldRun) return;
    if (this.ws && (this.ws.readyState === WebSocket.OPEN || this.ws.readyState === WebSocket.CONNECTING)) return;
    const url = `${BACKEND_URL.replace(/^http/, "ws")}/api/ws`;
    const ws = new WebSocket(url);
    this.ws = ws;
    ws.onopen = () => {
      this.retry = 0;
      this.boards.forEach((b) => ws.send(JSON.stringify({ action: "subscribe", board_id: b })));
    };
    ws.onmessage = (e) => {
      let msg;
      try { msg = JSON.parse(e.data); } catch (err) { console.error("[ws] mensaje inválido", err); return; }
      this.handlers.forEach((h) => h(msg));
    };
    ws.onclose = () => {
      this.ws = null;
      if (!this.shouldRun) return;
      const delay = Math.min(15000, 1000 * 2 ** this.retry++);
      this.timer = setTimeout(() => this._open(), delay);
    };
    ws.onerror = () => { try { ws.close(); } catch (err) { console.debug("[ws] close tras error", err); } };
  }

  disconnect() {
    this.shouldRun = false;
    clearTimeout(this.timer);
    this.boards.clear();
    if (this.ws) { try { this.ws.close(); } catch (err) { console.debug("[ws] close", err); } }
    this.ws = null;
  }

  on(handler) {
    this.handlers.add(handler);
    return () => this.handlers.delete(handler);
  }

  subscribeBoard(boardId) {
    this.boards.add(boardId);
    if (this.ws?.readyState === WebSocket.OPEN) {
      this.ws.send(JSON.stringify({ action: "subscribe", board_id: boardId }));
    }
  }

  unsubscribeBoard(boardId) {
    this.boards.delete(boardId);
    if (this.ws?.readyState === WebSocket.OPEN) {
      this.ws.send(JSON.stringify({ action: "unsubscribe", board_id: boardId }));
    }
  }
}

export const realtime = new RealtimeClient();
